export default __webpack_public_path__ + "assets/images/c377073433057cff726fb6ab64785688.png";